module.exports = __webpack_public_path__ + "img/euroMillions_icon.69ad6c72.png";